<style >
  .searchresult em {
    background-color: yellow;
  }
</style>
<template>
<div>
  <v-text-field clearable
    v-model="icd10"
    append-icon="search"
    @click:append="showSearch"
    @keypress.enter="$emit('input', icd10)"
    @keypress.ctrl.s="showSearch"
    :label="label"
    :persistent-hint="persistentHint"
    :hint="hint" />

  <v-bottom-sheet v-model="searchsheet" >
    <v-card flat >
      <v-card-title class="pa-0 overline grey lighten-2" >
        search ICD-10 codes
        <v-spacer/>
        <v-btn @click="searchsheet=false" icon small ><v-icon small >close</v-icon></v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-title class="pa-0" >
        <v-text-field clearable autofocus persistent-hint box
          v-model="search"
          id="icd-10-search"
          @click:clear="results=null"
          @keypress.ctrl.c="search=''"
          label="Search for a ICD-10 code"
          hint="You can search using a keyword, or on the ICD-10 code itself" />
      </v-card-title>
      <v-divider/>
      <v-card-text
        style="overflow-y:auto;height:500px;"
        class="pb-0 searchresult" >
        <template v-if="search && search.length > 0" >
          <div class="caption" v-text="searchSummary" />

          <v-list dense v-if="results && results.hits" >
            <template v-for="res in results.hits" >
              <v-list-tile @click="setSelected(res)" >
                <v-list-tile-action>
                  <v-icon small
                    v-if="selected && selected.length > 0 && selected.indexOf(res.name) > -1" >
                    check_box</v-icon>
                  <v-icon small v-else >check_box_outline_blank</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-text="res.name" />
                  <v-list-tile-sub-title v-text="res._formatted.description" />
                </v-list-tile-content>
              </v-list-tile>
              <v-divider :key="`div-${res.id}`" />
            </template>
          </v-list>
        </template>

      </v-card-text>
      <v-card-actions class="grey lighten-4" >
        <v-btn flat >cancel</v-btn>
        <v-spacer/>
        <template v-if="selected && selected.length > 0" >
          <span v-for="(code, index) in selected" :key="code" >
            <span v-if="index > 0" class="ml-1" >/</span>
            <v-chip outline label small close
              @input="setSelected({name: code})" >{{code}}</v-chip>
          </span>
        </template>

        <v-btn color="primary"
          :disabled="!selected || selected.length===0"
          @click="completeSearch" >Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</div>
</template>
<script>
const URL = 'https://ms-2e5226d4aade-156.saas.meili.dev'
const KEY = 'e4772fdf7f9010f072cb98c391348e53d7b81ebf'

export default {
  name: 'ICDInput',
  props: {
    value: { type: String },
    hint: { type: String, required: false },
    label: { type: String, required: false },
    persistentHint: { type: Boolean, default: false }
  },
  data () {
    return {
      icd10: '',
      search: '',
      timeout: null,
      timeoutInterval: 500,
      results: [],
      selected: [],
      resultsToShow: 20,
      searchsheet: false
    }
  },
  mounted () { this.icd10 = this.value },
  watch: {
    icd10 () { this.$emit('input', this.icd10) },
    search () {
      // this.$emit('input', this.icd10)
      this.debounceSearch()
    },
    searchsheet () {
      if (this.searchsheet === true) {
        setTimeout(() => {
          document.getElementById('icd-10-search').focus()
        }, 500)
      }
    }
  },
  computed: {
    selectedFormatted () {
      if (this.selected && this.selected.length > 0) {
        return this.selected.join(' / ')
      }
    },
    headers () {
      return {
        'Content-Type': 'application/json;charset=utf-8',
        //  'Authorization': 'Bearer ' + KEY,
        'X-MEILI-API-KEY': KEY
      }
    },
    query () {
      return {
        q: this.search,
        matches: true,
        limit: this.resultsToShow,
        attributesToHighlight: ['name', 'description']
        // sort: ['name:asc']
      }
    },
    searchSummary () {
      let res = this.results
      if (res && res.hits) {
        return `Showing ${res.hits.length} of ${res.nbHits} results for '${this.search}' in ${res.processingTimeMs} ms.`
      }
      return null
    }
  },
  methods: {
    showSearch () {
      if (this.icd10) { this.search = this.icd10 }
      this.searchsheet = true
      this.debounceSearch()
    },
    setSelected (res) {
      if (res) {
        let index = this.selected.indexOf(res.name)
        if (index === -1) {
          this.selected.push(res.name)
        } else {
          this.selected.splice(index, 1)
        }
      }
    },
    debounceSearch () {
      if (this.timeout) {
        window.clearTimeout(this.timeout)
      }
      this.timeout = window.setTimeout(this.doSearch, this.timeoutInterval)
    },
    async doSearch () {
      this.timeout = null
      let options = {
        body: JSON.stringify(this.query),
        method: 'post',
        headers: this.headers
      }
      let url = URL + '/indexes/codes/search'
      const res = await fetch(url, options)
      this.results = await res.json()
    },
    completeSearch () {
      this.icd10 = this.selectedFormatted
      this.searchsheet = false
      this.selected = []
      this.search = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// IcdInput.vue?94562980